import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { WhatsappNavbarComponent } from 'src/app/components/whatsapp-navbar/whatsapp-navbar.component';

@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss'],
  standalone: true,
  imports: [CommonModule, IonicModule, WhatsappNavbarComponent],
})
export class MainLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
